export const TOONS_ACTION = 'TOONS_ACTION';
export const TOONS_SUCCESS_ACTION = 'TOONS_SUCCESS_ACTION';
export const TOONS_FAILURE_ACTION = 'TOONS_FAILURE_ACTION';
